import http from './http'
import type { Notification } from '@/types/api'

export const notificationsService = {
  async list(): Promise<Notification[]> {
    const { data } = await http.get<Notification[]>('/notifications')
    return data
  },

  async markAllRead(): Promise<void> {
    await http.post('/notifications/read-all')
  },

  async clearAll(): Promise<void> {
    await http.delete('/notifications')
  },
}
